import React from 'react';
import { Drawer } from '@material-ui/core';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import clsx from 'clsx';

import { actions as reduxActions } from './reducers';
import CheckNumber from '../../pages/checkNumber/CheckNumber';
import styles from './styles';
import history from '../../../history';
import withUserCheck from '../../utils/withUserCheck';
import { isDefined } from '../../utils/isDefined';

const RightPanel = ({
  open,
  closePanel,
  classes,
  isPartnerOrDstnyAdmin,
  number
}) => {
  const onResizeClick = () => {
    if (isDefined(number)) {
      closePanel();
      history.push(`/admin/numberLookup#${number}`);
    }
  };

  return (
    <Drawer
      anchor={'right'}
      open={open}
      onClose={closePanel}
      transitionDuration={200}
    >
      <div className={classes.label}>
        <i
          className={clsx('far fa-chevron-double-right', classes.closeIcon)}
          onClick={closePanel}
        ></i>
        {isPartnerOrDstnyAdmin && isDefined(number) && (
          <i
            className={clsx('far fa-expand-alt', classes.expandIcon)}
            onClick={onResizeClick}
          ></i>
        )}
      </div>
      <CheckNumber fromRightPanel={true} />
    </Drawer>
  );
};

const mapStatetoProps = ({ rightPanel }) => {
  return {
    open: rightPanel.open,
    number: rightPanel.number?.number
  };
};

const mapDispatchToProps = {
  closePanel: reduxActions.closeRightPanel
};

export default flowRight(
  withUserCheck,
  connect(mapStatetoProps, mapDispatchToProps),
  withStyles(styles)
)(RightPanel);
